'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reminders = require('./reminders.add');

var _reminders2 = _interopRequireDefault(_reminders);

var _reminders3 = require('./reminders.complete');

var _reminders4 = _interopRequireDefault(_reminders3);

var _reminders5 = require('./reminders.delete');

var _reminders6 = _interopRequireDefault(_reminders5);

var _reminders7 = require('./reminders.info');

var _reminders8 = _interopRequireDefault(_reminders7);

var _reminders9 = require('./reminders.list');

var _reminders10 = _interopRequireDefault(_reminders9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  add: _reminders2.default, complete: _reminders4.default, delete: _reminders6.default, info: _reminders8.default, list: _reminders10.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/slack/methods/reminders.js
// module id = 435
// module chunks = 0